import React from 'react';
import MarkdownDocPage from '../../components/docs/MarkdownDocPage';
import content from '../../content/sentry-docs/analytics/stats.md?raw';

const AnalyticsStats: React.FC = () => {
  return <MarkdownDocPage content={content} />;
};

export default AnalyticsStats;
